import { render } from "./switcher.html?vue&type=template&id=54ad2cc2&scoped=true&external"
import script from "./switcher.ts?vue&type=script&lang=js&external"
export * from "./switcher.ts?vue&type=script&lang=js&external"

import "./switcher.scss?vue&type=style&index=0&id=54ad2cc2&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54ad2cc2"],['__file',"src/components/ui/switcher/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "54ad2cc2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('54ad2cc2', __exports__)) {
    api.reload('54ad2cc2', __exports__)
  }
  
  module.hot.accept("./switcher.html?vue&type=template&id=54ad2cc2&scoped=true&external", () => {
    api.rerender('54ad2cc2', render)
  })

}


export default __exports__